﻿import React from 'react';
import { useNavigate } from 'react-router-dom';

import Constant from 'utils/constants';
import { useLoggedInUser } from 'hooks';
import { isClient } from 'helpers/user';
import { useBranch } from 'components/BranchProvider';

const requirePersonalInformation = (WrappedComponent) => {
  function RequirePersonalInformation(props) {
    const user = useLoggedInUser();
    const [branch] = useBranch();
    const navigate = useNavigate();

    React.useEffect(() => {
      if (branch && !branch.skip_request_more_information) {
        if (
          !user.migrated &&
          user.profile.state === Constant.user.profile.state.partial &&
          isClient(user) &&
          user.profile.has_hq_completed
        ) {
          navigate('/add-personal-information', { replace: true });
          return;
        } else if (
          !user.migrated &&
          isClient(user) &&
          user.profile.has_hq_completed &&
          !user.profile.time_zone
        ) {
          navigate('/add-time-zone', { replace: true });
          return;
        }
      }
    }, [user, navigate, branch]);
    return <WrappedComponent {...props} />;
  }
  return RequirePersonalInformation;
};

export default requirePersonalInformation;
